import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackExitedFullScreen.meta';

export type ExitedFullScreenParams = {
  location?: 'pdf' | 'video';
};

export const useTrackExitedFullScreen = () => {
  const { track } = useAnalyticsUtilities();

  const trackExitedFullScreen = useCallback(
    (params?: ExitedFullScreenParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackExitedFullScreen };
};
